import { getSelectedTechnique } from "../../../helpers/helper";

const singleColorPositionTechnique = [
  "Laser Engraving",
  "Gold Foil Debossing",
  "Silver Foil Debossing",
  "Blind Debossing",
];
const gradientColorPositionTechnique = ["Screen Printing", "Embroidery"];
const techniqueTobeSend = [
  { "Laser Engraving": "laser_engraving" },
  { "Blind Debossing": "blind_debossing" },
  { "Silver Foil Debossing": "silver_foil_debossing" },
  { "Gold Foil Debossing": "gold_foil_debossing" },
];
export function CheckTechniqueSingleColor(): boolean {
  return singleColorPositionTechnique.includes(
    getSelectedTechnique()?.techniqueName
  );
}

export function GetSelectedTechnique() {
    const index = techniqueTobeSend.find((tech) => tech[getSelectedTechnique()?.techniqueName]);
    return Object.values(index)?.[0]
}

export function CheckTechniqueGradientSupport(): boolean {
  return gradientColorPositionTechnique.includes(
    getSelectedTechnique()?.techniqueName
  );
}

export function TechniqueBaseSingleColor(): number[] {
  switch (getSelectedTechnique()?.techniqueName) {
    case "Laser Engraving":
      return [192, 192, 192];
    case "Gold Foil Debossing":
      return [255, 215, 0];
    case "Silver Foil Debossing":
      return [190, 190, 190];
    case "Blind Debossing":
      return [185, 185, 185];
    default:
      return [0, 0, 0];
  }
}
